import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step12', 'Steps', {
	data() {
		return {
			step: null,
			activeRadio: 0,
			activeInsideElement: null,
			activeInsideElementItem: null,
			activeOutsideElement: null,
			activeOutsideElementItem: null,
			sidesRadio: [
				{ label: 'На одну сторону', value: 0 },
				{ label: 'На две стороны', value: 1 },
			],
			showDobor: false,
			showStep: false,
		};
	},
	props: ['doorCover', 'molding', 'doorType', 'molding'],
	created() {
		this.getDataStep();
	},
	methods: {
		getDataStep: function () {
			let context = this;
			this.step=null;
			this.activeRadio=0;
			this.activeInsideElement=null;
			this.activeInsideElementItem=null;
			this.activeOutsideElement=null;
			this.activeOutsideElementItem=null;
			this.showDobor=false;
			this.showStep=false;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep12', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step = response.data.result;
					let doorFrameSide = this.sidesRadio.filter((item) => {
						if (item.value === this.activeRadio) return item;
					})[0];

					const insideFrames = context.step.insideDoorFrame.filter((element, index) => {
						if (element.items !== undefined && element.items.length) {
							return element;
						}
					});

					if (insideFrames.length) {
						context.deletePositionKey(['step12']);
						this.setPropPosition({
							doorFrameSide: doorFrameSide,
						});
						context.activeInsideElement = 0;
						context.activeInsideElementItem = 0;
						context.showStep = true;
					} else {
						context.setPropPosition({ step12: 'skip' });
						context.showStep = false;
					}
				}
			});
		},
		setActiveRadio(value) {
			this.activeRadio = value;
			if (!this.activeRadio) {
				this.activeOutsideElement = null;
				this.activeOutsideElementItem = null;
			}
		},
		isDataStep: function () {
			return this.step;
		},
	},
	watch: {
		activeRadio(val) {
			const item = this.sidesRadio.filter((item) => {
				if (item.value === val) return item;
			})[0];

			item.value && this.step.dobor_size !== null ? (this.showDobor = true) : (this.showDobor = false);

			this.setPropPosition({ doorFrameSide: item });
		},
		molding(val) {
			this.step = null;
			this.getDataStep();
		},
		activeInsideElement: function (val, oldValue) {
			if (val === null) {
				this.setPropPosition({
					doorFrameInside: null,
				});
				return;
			}

			this.setPropPosition({
				doorFrameInside: {
					id: this.step.insideDoorFrame[val].id,
					title: this.step.insideDoorFrame[val].title,
					image: this.step.insideDoorFrame[val].image,
				},
			});

			// if (this.step.insideDoorFrame[val].items.length < 2) {
			// 	this.activeInsideElementItem = 0;
			// } else {
			// 	this.activeInsideElementItem = null;
			// 	this.setPropPosition({
			// 		doorFrameInsideElement: null,
			// 	});
			// }

			if (oldValue === undefined || oldValue === null) return;
			if (val.id !== oldValue.id) {
				if (this.activeInsideElementItem !== null) {
					this.activeInsideElementItem = null;
				}
				this.setPropPosition({
					doorFrameInsideElement: null,
				});
			}
		},
		activeInsideElementItem: function (val) {
			if (val === null) return;
			let price = 0;

			const activeItem = this.step.insideDoorFrame[this.activeInsideElement].items[val];
			const nacenkaType = this.doorCover.price_nacenka_type;
			const nacenkaPrice = this.doorCover.price_nacenka_pogonag;
			const title = this.step.insideDoorFrame[this.activeInsideElement]['title'];
			if (title.trim().toLowerCase() === 'наличники') {
				if (nacenkaType) {
					price = (Number(activeItem.price) + Number(activeItem.price) * (nacenkaPrice / 100)) * activeItem.kf;
				} else {
					price = (Number(activeItem.price) + nacenkaPrice) * activeItem.kf;
				}
			}
			if (title.trim().toLowerCase() === 'капитель') {
				if (this.doorType !== undefined) {
					if (this.doorType.title === 'Одностворчатая') {
						if (nacenkaType) {
							price = activeItem.price + activeItem.price * (nacenkaPrice / 100);
						} else {
							price = activeItem.price + nacenkaPrice;
						}
					} else if (this.doorType.title === 'Двухстворчатая') {
						if (nacenkaType) {
							price = activeItem.price_2 + activeItem.price_2 * (nacenkaPrice / 100);
						} else {
							price = activeItem.price_2 + nacenkaPrice;
						}
					}
				}
			}
			let resultTitle =
				this.step.insideDoorFrame[this.activeInsideElement].title.trim().toLowerCase() === 'наличники' ? 'Количество внешних наличников' : 'Количиство внешних капителей';
			this.setPropPosition({
				doorFrameInsideElement: {
					...activeItem,
					resultRowTitle: resultTitle,
					price: price,
				},
			});
		},
		activeOutsideElement: function (val, oldVal) {
			if (val !== null) {
				this.setPropPosition({
					doorFrameOutside: {
						id: this.step.outsideDoorFrame[val].id,
						title: this.step.outsideDoorFrame[val].title,
						image: this.step.outsideDoorFrame[val].image,
					},
				});
			} else {
				this.setPropPosition({
					doorFrameOutside: null,
				});
			}
			if (val === oldVal) return;
			if (this.activeOutsideElementItem !== null) {
				this.activeOutsideElementItem = null;
			}
		},
		activeOutsideElementItem: function (val) {
			if (this.activeOutsideElement !== null && val !== null) {
				let price = 0;

				const activeItem = this.step.outsideDoorFrame[this.activeOutsideElement].items[val];
				const nacenkaType = this.doorCover.price_nacenka_type;
				const nacenkaPrice = this.doorCover.price_nacenka_pogonag;
				const title = this.step.outsideDoorFrame[this.activeOutsideElement]['title'];

				if (title.trim().toLowerCase() === 'наличники') {
					if (nacenkaType) {
						price = (activeItem.price + activeItem.price * (nacenkaPrice / 100)) * activeItem.kf;
					} else {
						price = (activeItem.price + nacenkaPrice) * activeItem.kf;
					}
				}

				if (title.trim().toLowerCase() === 'капитель') {
					if (this.doorType !== undefined) {
						if (this.doorType.title === 'Одностворчатая') {
							if (nacenkaType) {
								price = activeItem.price + activeItem.price * (nacenkaPrice / 100);
							} else {
								price = activeItem.price + nacenkaPrice;
							}
						} else if (this.doorType.title === 'Двухстворчатая') {
							if (nacenkaType) {
								price = activeItem.price_2 + activeItem.price_2 * (nacenkaPrice / 100);
							} else {
								price = activeItem.price_2 + nacenkaPrice;
							}
						}
					}
				}
				let resultTitle =
					this.step.outsideDoorFrame[this.activeOutsideElement].title.trim().toLowerCase() === 'наличники' ? 'Количество внутренних наличников' : 'Количиство внутренних капителей';
				this.setPropPosition({
					doorFrameOutsideElement: {
						...activeItem,
						resultRowTitle: resultTitle,
						price: price,
					},
				});
			} else {
				this.setPropPosition({
					doorFrameOutsideElement: null,
				});
			}
		},
		// molding(val, oldValue) {
		// 	if (val === oldValue) return;
		// 	this.activeInsideElement = null;
		// 	this.activeInsideElementItem = null;
		// 	this.activeOutsideElement = null;
		// 	this.activeOutsideElementItem = null;

		// 	this.setPropPosition({
		// 		doorFrameInside: null,
		// 		doorFrameInsideElement: null,
		// 		doorFrameOutside: null,
		// 		doorFrameOutsideElement: null,
		// 	});
		// 	this.getDataStep();
		// },
		showDobor(val) {
			if (val) {
				let kf = this.step.dobor_size.kf || 1;
				let price = 0;
				const nacenkaType = this.doorCover.price_nacenka_type;
				if (nacenkaType) {
					price = (Number(this.step.dobor_size.price) + Number(this.step.dobor_size.price) * (this.doorCover.price_nacenka_pogonag / 100)) * kf;
				} else {
					price = (Number(this.step.dobor_size.price) + this.doorCover.price_nacenka_pogonag) * kf;
				}
				this.setPropPosition({
					dobor: { ...this.step.dobor_size, price: price },
				});
			} else {
				this.setPropPosition({
					dobor: null,
				});
			}
		},
	},
	template: `
<div class="config-block" v-if="showStep">
	<div class="config-block__inner" v-if="isDataStep()">
		<div class="config-block__wrap">
			<ConfigBlockWrapTitle tippyContent="Обрамление двери">Обрамление двери</ConfigBlockWrapTitle>
			<RadioGroup :options="sidesRadio" name="framingSides" :selected="sidesRadio[0].value"
				v-on:selectedValue="setActiveRadio" />
		</div>
		<div class="config-block__inner mt-48">
			<div class="config-block__wrap">
				<div class="config-block__wrap-title">Внешняя сторона</div>
				<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="2">
					<div class="swiper-slide" v-for="(slide, index) of step.insideDoorFrame">
						<SimpleItem :image="slide.image" :title="slide.title" :key="index"
							:class="{active: activeInsideElement === index}" v-on:setActive="activeInsideElement = index" />
					</div>
				</Swiper>
			</div>
			<div class="config-block__wrap mt-48" v-show="activeInsideElement!== null">
				<div class="config-block__wrap-title">
					{{step.insideDoorFrame[activeInsideElement] !== undefined && step.insideDoorFrame[activeInsideElement].title === 'Наличники' ? "Модель наличника" : "Модель капители"}}
				</div>
				<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
					<div class="swiper-slide" v-for="(slide, index) of step.insideDoorFrame[activeInsideElement]?.items">
						<SimpleItem
							v-if="step.insideDoorFrame[activeInsideElement].title === 'Наличники' && (doorType.title === 'Одностворчатая' || doorType.title === 'Двухстворчатая')" :image="slide.image"
							:price="doorCover.price_nacenka_type ? (slide.price + slide.price * (doorCover.price_nacenka_pogonag / 100)) * slide.kf :(slide.price + doorCover.price_nacenka_pogonag) * slide.kf" :priceType="2" :key="index"	:class="{active: activeInsideElementItem === index}" v-on:setActive="activeInsideElementItem = index" />
						<SimpleItem
							v-if="step.insideDoorFrame[activeInsideElement].title === 'Капитель' && doorType.title === 'Одностворчатая'" :image="slide.image"
							:price="doorCover.price_nacenka_type ? slide.price + slide.price * (doorCover.price_nacenka_pogonag / 100) : slide.price + doorCover.price_nacenka_pogonag" :priceType="2" :key="index"	:class="{active: activeInsideElementItem === index}" v-on:setActive="activeInsideElementItem = index" />
						<SimpleItem v-if="step.insideDoorFrame[activeInsideElement].title === 'Капитель' && doorType.title === 'Двухстворчатая'" :image="slide.image" :price="doorCover.price_nacenka_type ? slide.price_2 + slide.price_2 * (doorCover.price_nacenka_pogonag/100) :slide.price_2 + doorCover.price_nacenka_pogonag" :priceType="2" :key="index"	:class="{active: activeInsideElementItem === index}" v-on:setActive="activeInsideElementItem = index" />
					</div>
				</Swiper>
			</div>
		</div>
		<div class="config-block__inner mt-48" v-show="activeRadio">
			<div class="config-block__wrap">
				<div class="config-block__wrap-title">Внутренняя сторона</div>
				<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="2">
					<div class="swiper-slide" v-for="(slide, index) of step.outsideDoorFrame">
						<SimpleItem :image="slide.image" :title="slide.title" :key="index"
							:class="{active: activeOutsideElement === index}" v-on:setActive="activeOutsideElement = index" />
					</div>
				</Swiper>
			</div>
			<div class="config-block__wrap mt-48" v-show="activeOutsideElement !== null " >
				<div class="config-block__wrap-title">
					{{step.outsideDoorFrame[activeOutsideElement] !== undefined && step.outsideDoorFrame[activeOutsideElement].title === 'Наличники'? "Модель наличника" : "Модель капители"}}
				</div>
				<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
					<div class="swiper-slide" v-for="(slide, index) of step.outsideDoorFrame[activeOutsideElement]?.items">
						<SimpleItem v-if="step.outsideDoorFrame[activeOutsideElement].title === 'Наличники' && (doorType.title === 'Одностворчатая' || doorType.title === 'Двухстворчатая')" :image="slide.image"
						:price="doorCover.price_nacenka_type ? (slide.price + slide.price * (doorCover.price_nacenka_pogonag / 100)) * slide.kf : (slide.price + doorCover.price_nacenka_pogonag) * slide.kf" :priceType="2" :key="index" :class="{active: activeOutsideElementItem === index}" v-on:setActive="activeOutsideElementItem = index"/>
						<SimpleItem v-if="step.outsideDoorFrame[activeOutsideElement].title === 'Капитель' && doorType.title === 'Одностворчатая'" :image="slide.image" :price="doorCover.price_nacenka_type ? slide.price + slide.price * (doorCover.price_nacenka_pogonag/100) : slide.price + doorCover.price_nacenka_pogonag" :priceType="2" :key="index" :class="{active: activeOutsideElementItem === index}" v-on:setActive="activeOutsideElementItem = index"/>
						<SimpleItem v-if="step.outsideDoorFrame[activeOutsideElement].title === 'Капитель' && doorType.title === 'Двухстворчатая'" :image="slide.image" :price="doorCover.price_nacenka_type ? slide.price_2 + slide.price_2 * (doorCover.price_nacenka_pogonag/100) : slide.price_2 + doorCover.price_nacenka_pogonag" :priceType="2" :key="index" :class="{active: activeOutsideElementItem === index}" v-on:setActive="activeOutsideElementItem = index"/>
					</div>
				</Swiper>
			</div>
		</div>
		<div class="config-block__wrap mt-48 w-100p sm:w-50p" v-if="showDobor">
			<ConfigBlockWrapTitle tippyContent="Доборы">Доборы</ConfigBlockWrapTitle>
			<InputDisabled name="dobory" label="Ширина добора, мм" :value="step.dobor_size.razmer"/>
			<div class="config-slider__price-v2" style="margin-top:12px;">+ {{doorCover.price_nacenka_type ? (step.dobor_size.price + step.dobor_size.price * (this.doorCover.price_nacenka_pogonag / 100)) * step.dobor_size.kf : (step.dobor_size.price + this.doorCover.price_nacenka_pogonag) * step.dobor_size.kf}} руб</div>
		</div>
	</div>
	<div v-else>
		<div class="config-block__wrap">
			<div class="config-block__wrap-title">Обрамление двери</div>
			<div class="config-block__row flex">
				<PuSkeleton width="100px" height="24px" style="margin: 0 30px 0 0" />
				<PuSkeleton width="100px" height="24px" />
			</div>
		</div>
		<div class="config-block__wrap">
			<div class="config-block__wrap-title">Внешняя сторона</div>
			<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="2">
				<div class="swiper-slide" v-for="(slide, index) of [1,2]">
					<PuSkeleton height="200px" />
				</div>
			</Swiper>
		</div>
		<div class="config-block__wrap mt-48 w-100p sm:w-50p">
			<div class="config-block__wrap-title">Доборы</div>
			<PuSkeleton height="75px" />
		</div>
	</div>
</div>
`,
});
